import { css } from 'linaria';

export const kitchenGalleryTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const kitchenCatalogGrid = css`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 420px 292px 104px auto;
  width: 100%;
  padding: 0;
  margin-bottom: 32px;
  list-style: none;

  @media (--only-tablet) {
    grid-template-rows: 300px 196px 80px auto;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: 300px 80px auto;
  }
`;

export const kitchenCatalogCart = css`
  &:nth-of-type(1) {
    @media (--from-desktop) {
      height: 736px;
    }

    @media (--from-tablet) {
      grid-row-start: span 2;
    }

    @media (--only-tablet) {
      height: 520px;
    }
  }

  &:nth-of-type(3) {
    @media (--from-desktop) {
      height: 420px;
    }

    @media (--from-tablet) {
      grid-row-start: span 2;
    }

    @media (--only-tablet) {
      height: 300px;
    }
  }
`;

export const kitchenCatalogImageWrapper = css`
  width: 100%;
  height: 309px;

  @media (--to-tablet) {
    height: 200px;
  }
`;

export const kitchenCatalogFirstImage = css`
  @media (--from-desktop) {
    height: 625px;
  }

  @media (--only-tablet) {
    height: 420px;
  }
`;

export const kitchenCatalogImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;
`;

export const kitchenCatalogCartContentWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 12px;
`;

export const kitchenCatalogCartCardTitle = css`
  &&&& {
    @media (--to-tablet) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const kitchenCatalogCardPriceWrapper = css`
  display: flex;
  align-items: center;
  height: 39px;

  @media (--to-tablet) {
    height: 32px;
  }
`;

export const kitchenCatalogCardPrice = css`
  && {
    && {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;

      @media (--to-tablet) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
`;

export const kitchenCatalogCardValue = css`
  && {
    font-weight: 800;
    font-size: 28px;
    line-height: 33px;

    @media (--to-tablet) {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;
